import { ISgSdkHandler, TriggerAction } from "./types";

declare const azAdWrapper: any;
declare const h5ads: any;
declare const sdkHandler: ISgSdkHandler;

export function showInterstitial() {
  return new Promise<void>(resolve => {
    sdkHandler.trigger(TriggerAction.BEFORE_PLAY_BUTTON_DISPLAY, {
      callback() {
        azAdWrapper.once(h5ads.AdEvents.CONTENT_PAUSED, () => {
          console.log('paused');
        });

        azAdWrapper.once(h5ads.AdEvents.CONTENT_RESUMED, () => {
          console.log('resumed');
          azAdWrapper.removeAllListeners(h5ads.AdEvents.CONTENT_PAUSED);
          azAdWrapper.removeAllListeners(h5ads.AdEvents.CONTENT_RESUMED);
          resolve();
        });

        azAdWrapper.showAd(h5ads.AdType.interstitial);
      },
    });
  });
}
